import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { BasicButtonStyle } from './style';
interface BasicButtonProps extends ButtonProps {
  onClick: () => void;
  icon?: React.ReactNode;
  label: React.ReactNode;
  selectedTab?: number;
  overallStatus?: string;
}

export const BasicButton: React.FC<BasicButtonProps> = (props) => {
  const { onClick, icon, label, variant, disabled, selectedTab, ...rest } = props;

  return (
    <BasicButtonStyle>
      <Button
        className={`basicButton ${selectedTab && 'radiusButton'}`}
        onClick={onClick}
        {...rest}
        variant={variant}
        disabled={disabled}>
        {icon && <span style={{ marginRight: 8 }}>{icon}</span>}
        {label}
      </Button>
    </BasicButtonStyle>
  );
};
